import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import API_URL from "../../config/ApiUrl";
import { getDocuments } from "../document/documentSlice";
import { getForms } from "../form/formSlice";

export const getFormExpiryConfig = createAsyncThunk(
  "ExpiryConfig/getForm",
  async (formId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.EXPIRY_CONFIG.GET_FORM}/${formId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const updateFormExpiryConfig = createAsyncThunk(
  "ExpiryConfig/updateForm",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(
        API_URL.EXPIRY_CONFIG.UPDATE_FORM,
        payload
      );
      const { active_payload } = getState().form;
      dispatch(getForms(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const getDocumentExpiryConfig = createAsyncThunk(
  "ExpiryConfig/getDocument",
  async (documentId, { rejectWithValue }) => {
    try {
      const { data } = await axios.get(
        `${API_URL.EXPIRY_CONFIG.GET_DOCUMENT}/${documentId}`
      );
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

export const updateDocumentExpiryConfig = createAsyncThunk(
  "ExpiryConfig/updateDocument",
  async (payload, { rejectWithValue, dispatch, getState }) => {
    try {
      const { data } = await axios.put(
        API_URL.EXPIRY_CONFIG.UPDATE_DOCUMENT,
        payload
      );
      const { active_payload } = getState().document;
      dispatch(getDocuments(active_payload));
      return data.data;
    } catch (error) {
      return rejectWithValue(error.data);
    }
  }
);

const expiryConfigSlice = createSlice({
  name: "expiryConfig",
  initialState: {
    config: null,
    loading: false,
  },
  reducers: {
    resetExpiryConfig(state) {
      state.config = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFormExpiryConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFormExpiryConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        state.loading = false;
      })
      .addCase(getFormExpiryConfig.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getDocumentExpiryConfig.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDocumentExpiryConfig.fulfilled, (state, action) => {
        state.config = action.payload;
        state.loading = false;
      })
      .addCase(getDocumentExpiryConfig.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { resetExpiryConfig } = expiryConfigSlice.actions;
export default expiryConfigSlice.reducer;
